import { c as _c } from "react/compiler-runtime";
import { IcoFileText224, IcoPlusSmall16 } from '@onefootprint/icons';
import { LinkButton, TextArea } from '@onefootprint/ui';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
import FormGrid from '../form-grid';
import UploadFile from '../upload-file';
const defaultValue = {
  certificate: ''
};
const PinnedServerCertificates = t0 => {
  const $ = _c(44);
  const {
    id,
    onSubmit,
    values
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create.form.pinnedServerCertificates"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== values.pinnedServerCertificates) {
    t2 = values.pinnedServerCertificates.length ? values.pinnedServerCertificates : [defaultValue];
    $[1] = values.pinnedServerCertificates;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      defaultValues: {
        pinnedServerCertificates: t2
      }
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const form = useForm(t3);
  let t4;
  if ($[5] !== form.control) {
    t4 = {
      control: form.control,
      name: "pinnedServerCertificates"
    };
    $[5] = form.control;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t4);
  let t5;
  if ($[7] !== append) {
    t5 = () => {
      append(defaultValue);
    };
    $[7] = append;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleAdd = t5;
  let t6;
  if ($[9] !== remove) {
    t6 = index => () => {
      remove(index);
    };
    $[9] = remove;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleRemove = t6;
  let t7;
  if ($[11] !== form || $[12] !== onSubmit) {
    t7 = form.handleSubmit(onSubmit);
    $[11] = form;
    $[12] = onSubmit;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <p className="text-label-2 text-primary mb-4 fp-text">{t8}</p>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== fields || $[19] !== form || $[20] !== handleRemove || $[21] !== t) {
    let t11;
    if ($[23] !== fields.length || $[24] !== form || $[25] !== handleRemove || $[26] !== t) {
      t11 = (field, index_0) => <UploadFile accept=".pem, .crt" cta={t(_temp2)} iconComponent={IcoFileText224} id={`certificate.${index_0}`} key={field.id} label={t(_temp3)} onChange={value => form.setValue(`pinnedServerCertificates.${index_0}.certificate`, value)} onRemove={fields.length >= 2 ? handleRemove(index_0) : undefined}><TextArea size="compact" autoFocus={true} id={`certificate.${index_0}`} placeholder={t(_temp4)} {...form.register(`pinnedServerCertificates.${index_0}.certificate`)} /></UploadFile>;
      $[23] = fields.length;
      $[24] = form;
      $[25] = handleRemove;
      $[26] = t;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    t10 = fields.map(t11);
    $[18] = fields;
    $[19] = form;
    $[20] = handleRemove;
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[28] !== t10) {
    t11 = <FormGrid>{t10}</FormGrid>;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t) {
    t12 = t(_temp5);
    $[30] = t;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== handleAdd || $[33] !== t12) {
    t13 = <LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" onClick={handleAdd}>{t12}</LinkButton>;
    $[32] = handleAdd;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== id || $[36] !== t11 || $[37] !== t13 || $[38] !== t7 || $[39] !== t9) {
    t14 = <form id={id} onSubmit={t7}>{t9}{t11}{t13}</form>;
    $[35] = id;
    $[36] = t11;
    $[37] = t13;
    $[38] = t7;
    $[39] = t9;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== form || $[42] !== t14) {
    t15 = <FormProvider {...form}>{t14}</FormProvider>;
    $[41] = form;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
export default PinnedServerCertificates;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.certificate.cta;
}
function _temp3($_1) {
  return $_1.certificate.label;
}
function _temp4($_2) {
  return $_2.certificate.placeholder;
}
function _temp5($_3) {
  return $_3.addMore;
}